

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// sendMessage
// SENDMESSAGE   
const SENDMESSAGE= createAsyncThunk(
  "sendMessage/sendMessage",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const sendMessageSlice = createSlice({
  name: "sendMessageSlice",
  initialState: {
    sendMessage: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsendMessage: (state) => {
        state.sendMessage.loading = false
        state.sendMessage.error = false
        state.sendMessage.data = []
        state.sendMessage.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SENDMESSAGE.fulfilled, (state, action) => {
      state.sendMessage = {
        ...state.sendMessage,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDMESSAGE.pending, (state, action) => {
      state.sendMessage = {
        ...state.sendMessage,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SENDMESSAGE.rejected, (state, action) => {
      state.sendMessage = {
        ...state.sendMessage,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const sendMessageAction = {
    SENDMESSAGE,
};

export { sendMessageAction };
export default sendMessageSlice.reducer;
export const {setInitialStateOfsendMessage} = sendMessageSlice.actions